import { axiosInstance } from 'api/instance';
import { usageEndpoints } from '../usage';

const getUsageData = (start, end, page) =>
  axiosInstance.get(usageEndpoints.usage_data(), {
    params: {
      start_date: start,
      end_date: end,
      page: page
    }
  });

const getChartData = (start, end) =>
  axiosInstance.get(usageEndpoints.chart_data(), {
    params: {
      start_date: start,
      end_date: end
    }
  });

export const usageRequests = {
  getUsageData,
  getChartData
};
